import React, { useState, useEffect } from "react";
import {
  SearchInput,
  INPUT_SIZES,
  Chip,
  IconCheckCircle,
  IconRadioButtonUnchecked,
} from "cdk-radial";
import styled from "styled-components";

const SearchBar = styled(SearchInput)`
  flex: 0 0 50%;
`;

const FilterBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem;
  gap: 1rem;
`;

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const filterOptions = ["All", "Enabled", "Disabled"];

const FilterBar = ({
  allList,
  selectedList,
  setDisplayedList,
  sortFn = (list) => [...list],
  getFilterByAttribute = (item) => item,
  getSearchByAttribute = (item) => item,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [checked, setChecked] = useState([true, false, false]);

  useEffect(() => {
    let filteredList = [...allList];

    if (checked[1]) {
      filteredList = [...selectedList];
    } else if (checked[2]) {
      const selectedAttributeList = selectedList.map((item) =>
        getFilterByAttribute(item)
      );
      filteredList = allList.filter(
        (item) => !selectedAttributeList.includes(getFilterByAttribute(item))
      );
    }

    if (searchTerm.trim()) {
      filteredList = filteredList.filter((item) =>
        getSearchByAttribute(item)
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
    }
    setDisplayedList(sortFn(filteredList));
  }, [allList, checked, searchTerm]);

  const handleOptionSelect = (value) => {
    const index = filterOptions.indexOf(value);
    const newChecked = filterOptions.map((_, i) => i === index);
    setChecked(newChecked);
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  return (
    <FilterBarContainer>
      <SearchBar
        clearButtonLabel="clearSearchInput"
        id="role-search"
        isAlwaysExpanded
        name="role-search"
        onChange={handleSearchChange}
        placeholder="Search by role name..."
        size={INPUT_SIZES.STANDARD}
        value={searchTerm}
      />
      <FilterContainer>
        <span>Filter By:</span>
        {filterOptions.map((label, i) => (
          <Chip
            key={label}
            icon={
              checked[i] ? <IconCheckCircle /> : <IconRadioButtonUnchecked />
            }
            isSelected={checked[i]}
            dataTestId={`role-filter-${label}`}
            label={label}
            value={label}
            hasCheckbox={true}
            onClick={handleOptionSelect}
          />
        ))}
      </FilterContainer>
    </FilterBarContainer>
  );
};

export default FilterBar;
